// Team API Service - Backend Integration
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';
import MockDataService from '../services/MockDataService';

const USE_MOCK = process.env.REACT_APP_USE_MOCK_DATA === 'true' || process.env.NODE_ENV === 'development';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

/**
 * Get teams with pagination
 * Gateway path: /gateway/registration/api/signup/organization/teams
 */
export const getTeams = async (params = {}) => {
  //console.log('🔍 teamService.getTeams called with params:', params);
  try {
    const response = await apiGet('/gateway/registration/api/signup/organization/teams', params);
    //console.log('✅ teamService.getTeams response:', response);
    return wrapResponse(response);
  } catch (error) {
    console.error('❌ teamService.getTeams error:', error);
    throw error; // Re-throw to let caller handle it
  }
};

/**
 * Create team
 * Gateway path: /gateway/registration/api/signup/organization/teams
 */
export const createTeam = async (data) => {
  const response = await apiPost('/gateway/registration/api/signup/organization/teams', data);
  return wrapResponse(response);
};

/**
 * Get team by ID
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}
 */
export const getTeamById = async (teamId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTeamById(teamId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/gateway/registration/api/signup/organization/teams/${teamId}`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/gateway/registration/api/signup/organization/teams/${teamId}`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTeamById(teamId);
    return wrapResponse(response.data);
  }
};

/**
 * Update team
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}
 */
export const updateTeam = async (teamId, data) => {
  const response = await apiPut(`/gateway/registration/api/signup/organization/teams/${teamId}`, data);
  return wrapResponse(response);
};

/**
 * Delete team
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}
 */
export const deleteTeam = async (teamId) => {
  const response = await apiDelete(`/gateway/registration/api/signup/organization/teams/${teamId}`);
  return wrapResponse(response);
};

/**
 * Get teams by department
 * Gateway path: /gateway/registration/api/signup/organization/departments/{deptId}/teams
 */
export const getTeamsByDepartment = async (deptId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTeamsByDepartment(deptId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/gateway/registration/api/signup/organization/departments/${deptId}/teams`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/gateway/registration/api/signup/organization/departments/${deptId}/teams`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTeamsByDepartment(deptId);
    return wrapResponse(response.data);
  }
};

/**
 * Get team members
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}/members
 */
export const getTeamMembers = async (teamId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTeamMembers(teamId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/gateway/registration/api/signup/organization/teams/${teamId}/members`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/gateway/registration/api/signup/organization/teams/${teamId}/members`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTeamMembers(teamId);
    return wrapResponse(response.data);
  }
};

/**
 * Assign team lead
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}/team-lead
 */
export const assignTeamLead = async (teamId, userId) => {
  const response = await apiPut(`/gateway/registration/api/signup/organization/teams/${teamId}/team-lead`, { userId });
  return wrapResponse(response);
};

/**
 * Get team capacity
 * Gateway path: /gateway/registration/api/signup/organization/teams/{teamId}/capacity
 */
export const getTeamCapacity = async (teamId) => {
  const response = await apiGet(`/gateway/registration/api/signup/organization/teams/${teamId}/capacity`);
  return wrapResponse(response);
};

// Service object for backward compatibility
export const teamService = {
  getTeams,
  createTeam,
  getTeamById,
  updateTeam,
  deleteTeam,
  getTeamsByDepartment,
  getTeamMembers,
  assignTeamLead,
  getTeamCapacity,
};

export default teamService;
